


import Map from 'ol/Map';
import * as ol_style from 'ol/style';

import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';

import { Vector as ol_layer_Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import { Point as ol_geom_Point } from 'ol/geom';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';

import { FrCoordinate, FrLayer } from 'gmap';
import { OlMapBaseComponent } from 'gmap';
import { SupervisionError, Site, Panel } from 'solar-bo';
import { catchError } from 'rxjs/operators';
import { OlObjectTypeEnum } from 'solar-bo';
import GeoJSON from 'ol/format/GeoJSON';
import { throwError } from 'rxjs';
import { MapMarkerHelper } from 'gmap';
import { MapSupervisionHelper } from './map-supervision-helper';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { mapcte } from 'gmap';
import IconOrigin from 'ol/style/IconOrigin';


export class MapSiteHelper {

  siteNameTextStyle = 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"';//'bold 12px Calibri,sans-serif';
  /**
   * Color for icon site
   */
  siteIconColor = "rgb(33 ,150 ,243)";//azulado
  /**
   * url of the icon
   */
  //siteIcon = "assets/ol/panel-solar-1.png";
  siteIcon="assets/ol/sitemarker.png";

/*   public static siteIcon = new ol_style.Icon(({
    //color: '#ece60f'
    crossOrigin: 'anonymous'
    , src: 'assets/ol/marker1.png'
    , scale: 1
    , anchor: [11, 44]
    , anchorXUnits: IconAnchorUnits.PIXELS
    , anchorYUnits: IconAnchorUnits.PIXELS
  })); */

  public static siteIcon = new ol_style.Icon(({
    //color: '#ece60f'
    crossOrigin: 'anonymous'
    , src: 'assets/ol/sitemarkerforlist.png'
    , scale: 1
    , anchor: [10, 30]
    , anchorXUnits: IconAnchorUnits.PIXELS
    , anchorYUnits: IconAnchorUnits.PIXELS
  }));

  public static markerStyle = new ol_style.Style({
    image: MapSiteHelper.siteIcon
  });



  
  constructor() {
    //   this.map=mapc.map;
  }
  /**
   * Vector layer for site boundaries
   * @param layername 
   * @param data 
   * @param id 
   * @param tooltip 
   * @returns 
   */
  static loadSiteGeometry(layername: string, data: any, id?: string, tooltip?: string) {

    let vectorSource = new ol_source_Vector({ features: (new GeoJSON()).readFeatures(data) });
    let vectorLayer = new ol_layer_Vector({
      source: vectorSource
    });
    let frlayer = new FrLayer(layername, id);
    vectorLayer[mapcte.frlayerinfo_FieldName] = frlayer;
    if (tooltip) {
      frlayer.tooltip = tooltip;
    }

    let style = new ol_style.Style({
      /*       fill: new ol_style.Fill({
              color: [203, 194, 185, 0.2]
            }), */
      stroke: new ol_style.Stroke({
        color: [33, 243, 239, 1],
        width: 2,
        lineCap: 'round'
      })
    });

    vectorLayer.setStyle(style);
    return vectorLayer;
  }


  markerCreate(parentLayer: any, lon: number, lat: number, id: any, text: string) {
    if (!parentLayer) {
      throwError("You need to provide parent layer in order to create a marker");
    }
    const feature = MapMarkerHelper.markerCreate(MapSiteHelper.markerStyle, lon, lat, id, text);
    parentLayer.getSource().addFeature(feature);

  }

  static drawSiteOnLayer(layer, sites: any): any {
    try {
      if (sites.length == 0) {
        return;
      }
      let mapSitesHelper = new MapSiteHelper();
      for (let x = 0; x < sites.length; x++) {
        let site: Site = sites[x];

        if (site.info.location != null) {
          mapSitesHelper.markerCreate(layer, site.info.location[0], site.info.location[1], site.id, site.name);
        }
      }

      return layer;

    } catch (ex) {
      console.log(ex);
      throw ex;
    }

  }

  /**
   * Draw site icon on map
   * @param map 
   * @param layerName 
   * @param layerId 
   * @param sites 
   * @param reload 
   */
  static drawSitesOnMap(map, layerName, layerId, sites: any, reload: boolean = true): any {

    try {
      if (sites.length == 0) {
        return;
      }

      let frlayerinfo = new FrLayer(layerName, layerId);
      frlayerinfo.icon="assets/ol/sitemarkerforlist.png";
      frlayerinfo.tooltip="Icon indicating the center of the site.";
      let layer = map.layerGetByFrid(frlayerinfo.id);
      if (layer && reload) {
        map.layerRemove(frlayerinfo.id);
      }
      layer = map.layerCreateVectorLayer(frlayerinfo);

      MapSiteHelper.drawSiteOnLayer(layer, sites);


      map.layerAdd(layer);
      if (sites.length == 1) {
        map.setZoom(12);
        let site: Site = sites[0];
        if (site.info.location) {
          map.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1], 15));
        }
      }
      else if (sites.length > 1) {
        map.setZoom(6);
      }
      else {
        map.setZoom(4);
      }

      return layer;
    } catch (ex) {
      console.log(ex);
      throw ex;
    }

  }

  /**
    * draw all site panels
    * @param site 
    * @param reslist 
    */
  public static drawSitePanelsOnMap(map: OlMapBaseComponent, site: Site, reslist: any[]) {
    const layerId = site.id + "_PANELS";
    let layerinfo: FrLayer = new FrLayer('Site vector panels', layerId, 17.8);
    let parentLayer = map.layerCreateVectorLayer(layerinfo);
    map.layerAdd(parentLayer);
    MapSiteHelper.drawSitePanelsOnLayer(parentLayer, site, reslist);
    return parentLayer;
  }



  public static drawSitePanelsOnLayer(parentLayer, site: Site, reslist: any[]) {
    let panel_locator_patternmaps: string = "";
    if (site.info.hasOwnProperty("panel_locator_pattern")) {
      panel_locator_patternmaps = site.info.panel_locator_pattern.maps;
    }

    for (let x = 0; x < reslist.length; x++) {
      let obj: Panel = reslist[x];
      MapSupervisionHelper.panelPolygonDraw(obj, parentLayer, panel_locator_patternmaps);
    }
  }
  /**
   * 
   * @param feature 
   * @param resolution 
   */
  public static siteMapStyle(feature, resolution) {

    let geom = feature.getGeometry();
    let styles = [];

    styles.push(MapSiteHelper.markerStyle);

    return styles;
  }

  SiteNameStroke = new ol_style.Stroke({
    color: [255, 255, 255, 0.8],
    width: 2
  });

  SiteNamefill = new ol_style.Fill({
    color: [0, 0, 0, 1]
  });


  public siteMapStyleFull(feature, resolution) {

    try {
      if (feature==undefined){
        return;
      }
      //let geom = feature.getGeometry();
      const extInfo: FrLayer = feature.frlayerinfo;
      let site: Site = extInfo.refObject;

      let title = feature.frlayerinfo.name;// + " \n " + site.info.power;
      if (title.length>=14){
        title=title.slice(0,14) + "...";
      }
      let scaleSize = 0.9;// Math.floor(resolution * 10000000000);
      //title=this.getText(title,feature,resolution);

      let textStyle = new ol_style.Text({
        text: title
        , font: this.siteNameTextStyle
        , scale: scaleSize
        //, fill: this.SiteNamefill
        , stroke: this.SiteNameStroke
        , offsetY: 6

      })

       let styleForText = new ol_style.Style({
       text:textStyle
      }); 
      
      //let styleForText =this.createTextStyle(title,feature, resolution);
      

      // text: this.createTextStyle(title,feature, resolution)

      let itemIcon: ol_style.Icon;
      /*       itemIcon = new ol_style.Icon(({
              color: "rgb(250, 0, 0)",
              crossOrigin: 'anonymous'
              , src: 'assets/ol/sitemarker.png'
              , scale: 1
              , anchor: [10, 34]
              , anchorXUnits: IconAnchorUnits.PIXELS
              , anchorYUnits: IconAnchorUnits.PIXELS
            })); */

      /*       itemIcon = new ol_style.Icon(({
              color: "rgb(250, 0, 0)",
              crossOrigin: 'anonymous'
              , src: 'assets/ol/sitemarker3.png'
              , scale: 1
              , anchor: [12, 44]
              , anchorXUnits: IconAnchorUnits.PIXELS
              , anchorYUnits: IconAnchorUnits.PIXELS
            })); */

      let mw = site.info.power;
      let scale = 0.4;
      let scalemin = 0.3;
      if (mw <= 10) {
        scale = scalemin + 0.2;
      }
      else if (mw > 10 && mw <= 20) {
        scale = scalemin + 0.3;
      }
      else if (mw > 20 && mw <= 50) {
        scale = scalemin + 0.4;
      }
      else if (mw > 50 && mw <= 100) {
        scale = scalemin + 0.5;
      }
      else if (mw > 100 && mw <= 250) {
        scale = scalemin + 0.6;
      }
      else if (mw > 250 && mw <= 500) {
        scale = scalemin + 0.7;
      }
      else if (mw > 500) {
        scale = scalemin + 0.8;
      }

      //scale=scale/Math.pow(resolution, 1/40)

      /*       let anchorY=42; //(42 / scale)+5; //(42 * scale) +10;
            if (scale>=1){
              anchorY=(42*scale);
            } else if (scale<1){
              anchorY=(42*scale)+5;
            }     */

      itemIcon = new ol_style.Icon(({
        color: this.siteIconColor,
        crossOrigin: 'anonymous'
        , src: this.siteIcon
        , scale: scale
        , anchorOrigin: IconOrigin.BOTTOM_LEFT
        , anchor: [0.5, 0]
        , anchorXUnits: IconAnchorUnits.FRACTION
        , anchorYUnits: IconAnchorUnits.FRACTION
      }));


      let markerStyle = new ol_style.Style({
        image: itemIcon
      });

      //markerStyle.getImage().setScale(1/Math.pow(resolution, 1/30));

      let styles = [styleForText, markerStyle];
      return styles;
    }
    catch (err) {
      console.log(err);
    }
  }

  txt_align = "center";
  txt_baseline = "middle";
  txt_size = "12px";
  txt_height = "1";
  txt_offsetX = parseInt("0", 10);//para recogerlo luego de la UI
  txt_offsetY = parseInt("0", 10);
  txt_weight = "normal";
  txt_placement = undefined;//  dom.placement ? dom.placement.value : undefined;
  txt_maxAngle = undefined;//  dom.maxangle ? parseFloat(dom.maxangle.value) : undefined;
  txt_overflow = undefined;//  dom.overflow ? dom.overflow.value == 'true' : undefined;
  txt_rotation = 0;// parseFloat(dom.rotation.value);
  txt_font = 'Arial Unicode MS';
  txt_color = "#000";
  txt_color_outline = "#FFF";

  createTextStyle(title, feature, resolution) {

    /*     if (dom.font.value == "'Open Sans'" && !openSansAdded) {
          var openSans = document.createElement('link');
          openSans.href = 'https://fonts.googleapis.com/css?family=Open+Sans';
          openSans.rel = 'stylesheet';
          document.getElementsByTagName('head')[0].appendChild(openSans);
          openSansAdded = true;
        } */
    let font = this.txt_weight + ' ' + this.txt_size + '/' + this.txt_height + ' ' + this.txt_font;
    let fillColor = this.txt_color;
    let outlineColor = this.txt_color_outline;
    let outlineWidth =3;

    return new ol_style.Text({
      textAlign: this.txt_align == '' ? undefined : this.txt_align,
      textBaseline: this.txt_baseline,
      font: font,
      text: this.getText(title,feature, resolution),
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({ color: outlineColor, width: outlineWidth }),
      offsetX: this.txt_offsetX,
      offsetY: this.txt_offsetY,
      placement: this.txt_placement,
      maxAngle: this.txt_maxAngle,
      overflow: this.txt_overflow,
      rotation: this.txt_rotation,
    });
  }
  txt_type = "shorten";
  txt_maxResolution = 1200 ;//1200;

  getText(title,feature, resolution) {

    let text:string =title;// feature.get('name');
    console.log("gettext res= " + resolution + " -----------" + this.txt_maxResolution);
    if (resolution > this.txt_maxResolution) {
      text = '';
    } else if (this.txt_type == 'hide') {
      text = '';
    } else if (this.txt_type == 'shorten') {
      text = text.substring(12);
    } else if (
      this.txt_type == 'wrap' &&
      (!this.txt_placement  || this.txt_placement != 'line')
    ) {
      text = this.stringDivider(text, 16, '\n');
    }

    return text;
  };

  // http://stackoverflow.com/questions/14484787/wrap-text-in-javascript
  stringDivider(str, width, spaceReplacer) {
    if (str.length > width) {
      let p = width;
      while (p > 0 && str[p] != ' ' && str[p] != '-') {
        p--;
      }
      if (p > 0) {
        let left;
        if (str.substring(p, p + 1) == '-') {
          left = str.substring(0, p + 1);
        } else {
          left = str.substring(0, p);
        }
        let right = str.substring(p + 1);
        return left + spaceReplacer + this.stringDivider(right, width, spaceReplacer);
      }
    }
    return str;
  }

}